// tslint:disable:max-line-length

import React from 'react';

export const FormCheck = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M13.7,1.6l-8.5,8.5L2.3,7.3L0.2,9.4l2.8,2.8l2.1,2.1l2.1-2.1l8.5-8.5C15.8,3.8,13.7,1.6,13.7,1.6z" />
    </svg>
  );
};
